/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Advanced_Confirm_ExitInputs */

const cs_builder_advanced_confirm_exit = /** @type {(inputs: Builder_Advanced_Confirm_ExitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zpět na vizuální? Nesynchronizované úpravy Typst zůstanou, dokud nesynchronizujete nebo neupravíte bloky.`)
};

const en_builder_advanced_confirm_exit = /** @type {(inputs: Builder_Advanced_Confirm_ExitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Return to visual? Unsynced Typst edits stay until you sync from visual or edit blocks.`)
};

/**
* | output |
* | --- |
* | "Return to visual? Unsynced Typst edits stay until you sync from visual or edit blocks." |
*
* @param {Builder_Advanced_Confirm_ExitInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_advanced_confirm_exit = /** @type {((inputs?: Builder_Advanced_Confirm_ExitInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Advanced_Confirm_ExitInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_advanced_confirm_exit(inputs)
	return cs_builder_advanced_confirm_exit(inputs)
});